import { createContext, useContext } from 'react';

interface WizardExposureContextValue {
  markExposed: () => void;
}

const WizardExposureContext = createContext<WizardExposureContextValue>({
  markExposed: () => {},
});

export const WizardExposureProvider = WizardExposureContext.Provider;

export const useWizardExposure = () => useContext(WizardExposureContext);
